export const generatedClaimEvidenceLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-claim-evidence-ledger",
  "operatingRule": "Every claim must carry source records, confidence, promotion blockers, allowed use, and a reproducible claim hash before it appears in customer-facing packages.",
  "claimCount": 6,
  "verifiedClaimCount": 3,
  "blockedClaimCount": 3,
  "gradeCounts": {
    "A-reviewable": 3,
    "D-blocked": 1,
    "C-partial": 2
  },
  "promotionAllowedClaimIds": [
    "claim-mercury-flux",
    "claim-de440-boundary",
    "claim-dtn"
  ],
  "blockedClaimIds": [
    "claim-helium3",
    "claim-spf-separation",
    "claim-mercury-core"
  ],
  "evidenceHashes": {
    "claims": "sha256-61b79784357e725eadaeaa05cb20796bb07c9b99d40d2423120354ee7aabad63",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030"
  },
  "claimRecords": [
    {
      "claimId": "claim-mercury-flux",
      "claim": "Mercury solar flux ranges roughly from 4.6x to 10.6x Earth, with mean near 6.7x.",
      "domain": "Energy",
      "status": "Verified",
      "impact": "High",
      "confidence": 0.92,
      "lastVerified": "2026-06-18",
      "notes": "Calculated by inverse square from Mercury's orbital distance range.",
      "sourceCoverage": {
        "sourceCount": 1,
        "missingSourceIds": [],
        "primarySourceCount": 1,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "sourceType": "official-factsheet",
            "recordHash": "fnv1a32-78229f8d",
            "uncertaintyMode": "Factsheet summary caveats; not a substitute for mission data.",
            "url": "https://science.nasa.gov/mercury/facts/"
          }
        ]
      },
      "evidenceScore": 92.64,
      "evidenceGrade": "A-reviewable",
      "commercialRiskWeight": 8,
      "promotionGate": {
        "promotionAllowed": true,
        "state": "verified-citable-beta-evidence",
        "allowedUse": "May be cited as beta verified context with source hashes attached.",
        "blockers": []
      },
      "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
    },
    {
      "claimId": "claim-de440-boundary",
      "claim": "DE440 should be treated as an operational ephemeris window, not a 50,000-year calendar.",
      "domain": "Ephemeris",
      "status": "Verified",
      "impact": "High",
      "confidence": 0.9,
      "lastVerified": "2026-06-18",
      "notes": "The app labels kernel coverage and avoids long-range precision claims.",
      "sourceCoverage": {
        "sourceCount": 2,
        "missingSourceIds": [],
        "primarySourceCount": 2,
        "sourceRecords": [
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "sourceType": "ephemeris-api",
            "recordHash": "fnv1a32-9335c241",
            "uncertaintyMode": "API table tolerance plus downstream numeric tolerance.",
            "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html"
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "sourceType": "ephemeris-event-software",
            "recordHash": "fnv1a32-97d74c96",
            "uncertaintyMode": "Kernel coverage plus geometric tolerance.",
            "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html"
          }
        ]
      },
      "evidenceScore": 93.8,
      "evidenceGrade": "A-reviewable",
      "commercialRiskWeight": 10,
      "promotionGate": {
        "promotionAllowed": true,
        "state": "verified-citable-beta-evidence",
        "allowedUse": "May be cited as beta verified context with source hashes attached.",
        "blockers": []
      },
      "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
    },
    {
      "claimId": "claim-helium3",
      "claim": "Mercury helium-3 is a possible solar-wind implantation hypothesis, not a verified resource.",
      "domain": "Resources",
      "status": "Hypothesis",
      "impact": "Medium",
      "confidence": 0.25,
      "lastVerified": "2026-06-18",
      "notes": "Requires concentration, extraction, and throughput evidence before promotion.",
      "sourceCoverage": {
        "sourceCount": 1,
        "missingSourceIds": [],
        "primarySourceCount": 1,
        "sourceRecords": [
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "sourceType": "mission-data-archive",
            "recordHash": "fnv1a32-7c477cc2",
            "uncertaintyMode": "Instrument/product calibration metadata.",
            "url": "https://pds.nasa.gov/datasearch/data-search/"
          }
        ]
      },
      "evidenceScore": 23.5,
      "evidenceGrade": "D-blocked",
      "commercialRiskWeight": 56.25,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-proof",
        "allowedUse": "May be shown as a reviewed hypothesis/context item, but not as commercial proof.",
        "blockers": [
          "Claim status is Hypothesis, not Verified.",
          "Confidence 0.25 is below 0.8 promotion threshold."
        ]
      },
      "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
    },
    {
      "claimId": "claim-spf-separation",
      "claim": "Vacuum anisotropic sheet forming and SPF/DB must be modeled as separate process cards.",
      "domain": "Manufacturing",
      "status": "Likely",
      "impact": "High",
      "confidence": 0.78,
      "lastVerified": "2026-06-18",
      "notes": "Avoids conflating cold/low-temperature anisotropy preservation with elevated-temperature SPF/DB.",
      "sourceCoverage": {
        "sourceCount": 1,
        "missingSourceIds": [],
        "primarySourceCount": 1,
        "sourceRecords": [
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "sourceType": "mission-data-archive",
            "recordHash": "fnv1a32-7c477cc2",
            "uncertaintyMode": "Instrument/product calibration metadata.",
            "url": "https://pds.nasa.gov/datasearch/data-search/"
          }
        ]
      },
      "evidenceScore": 65.8,
      "evidenceGrade": "C-partial",
      "commercialRiskWeight": 22,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-proof",
        "allowedUse": "May be shown as a reviewed hypothesis/context item, but not as commercial proof.",
        "blockers": [
          "Claim status is Likely, not Verified.",
          "Confidence 0.78 is below 0.8 promotion threshold.",
          "High-impact non-verified claim cannot support customer proof."
        ]
      },
      "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
    },
    {
      "claimId": "claim-dtn",
      "claim": "Disrupted interplanetary communications should use a store-and-forward planning model.",
      "domain": "Comms",
      "status": "Verified",
      "impact": "High",
      "confidence": 0.88,
      "lastVerified": "2026-06-18",
      "notes": "This supports contact-plan pages and autonomy-load scoring.",
      "sourceCoverage": {
        "sourceCount": 1,
        "missingSourceIds": [],
        "primarySourceCount": 1,
        "sourceRecords": [
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "sourceType": "communications-program-reference",
            "recordHash": "fnv1a32-61e03fe6",
            "uncertaintyMode": "Conceptual architecture until mission-specific link data exists.",
            "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/"
          }
        ]
      },
      "evidenceScore": 90.96,
      "evidenceGrade": "A-reviewable",
      "commercialRiskWeight": 12,
      "promotionGate": {
        "promotionAllowed": true,
        "state": "verified-citable-beta-evidence",
        "allowedUse": "May be cited as beta verified context with source hashes attached.",
        "blockers": []
      },
      "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
    },
    {
      "claimId": "claim-mercury-core",
      "claim": "Mercury's iron core is strategically interesting but not an early accessible surface resource.",
      "domain": "Resources",
      "status": "Likely",
      "impact": "High",
      "confidence": 0.7,
      "lastVerified": "2026-06-18",
      "notes": "Early body ledgers must distinguish surface/shallow resources from deep interior composition.",
      "sourceCoverage": {
        "sourceCount": 2,
        "missingSourceIds": [],
        "primarySourceCount": 2,
        "sourceRecords": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "sourceType": "official-factsheet",
            "recordHash": "fnv1a32-78229f8d",
            "uncertaintyMode": "Factsheet summary caveats; not a substitute for mission data.",
            "url": "https://science.nasa.gov/mercury/facts/"
          },
          {
            "sourceId": "pds",
            "title": "Planetary Data System",
            "trust": "primary",
            "sourceType": "mission-data-archive",
            "recordHash": "fnv1a32-7c477cc2",
            "uncertaintyMode": "Instrument/product calibration metadata.",
            "url": "https://pds.nasa.gov/datasearch/data-search/"
          }
        ]
      },
      "evidenceScore": 64.44,
      "evidenceGrade": "C-partial",
      "commercialRiskWeight": 30,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-proof",
        "allowedUse": "May be shown as a reviewed hypothesis/context item, but not as commercial proof.",
        "blockers": [
          "Claim status is Likely, not Verified.",
          "Confidence 0.7 is below 0.8 promotion threshold.",
          "High-impact non-verified claim cannot support customer proof."
        ]
      },
      "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
    }
  ],
  "ledgerHash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770"
}
;
